module.exports = __webpack_public_path__ + "img/icon-payment-sms-blue.0c7935c0.png";